<template>
	<div class="container">
		<div class="main">
			<div class="content">
				<div class="content-title">
					<!-- <div class="content-title-item" :class="active == 1 ? 'active':''" @click="setIndex(1)">全部</div> -->
					<el-select v-model="sortType" @change="setIndex(1)"  placeholder="" class="lable-select content-title-item" :class="active != 2 ? 'active':''">
						<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
					<!-- <div class="content-title-item" :class="active == 2 ? 'active':''" @click="setIndex(2)">精选</div> -->
				</div>
				<div class="scroll-container">
					<div   
						ref="scrollContainer"
						class="infinite-list"
						v-infinite-scroll="getDataList"
					>
					<div v-for="item in dataList" :key="item.id" >
						<articleCard :item="item"  :type="item.categoryScene"/>
					</div>
					<div v-if="loading" class="loading-text">加载中...</div>
					<div v-if="noMore" class="no-more-text">没有更多数据了</div>
					</div>
				</div>
				
				<!-- <Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange"/> -->
			</div>
			<div class="aside">
				<talkAside :id="talkId"/>
				<!-- <asideActive/> -->
			</div>
		</div>
	</div>
</template>

<script>
	import articleCard from '@/components/articleCard'
	import talkAside from '@/components/aside/talkAside'
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'home',
		components: {
			articleCard,
			talkAside,
		},
		data(){
			return {
				pageSize: 30,
				pageNum: 1,
				userId: '',
				dataList: [],
				total: 0,
				loading: false,
				talkId: '',
				active:1,
				options: [
					{
						value: 0,
						label: '新互动'
					}, 
					{
						value: 1,
						label: '最新'
					}, 
					{
						value: 2,
						label: '热门'
					}
				],
				sortType: 0
			}
		},
		created(){
			this.talkId = this.$route.query.id
			this.getDataList()
		},
		computed: {
			noMore() {
				return this.dataList.length >= this.total
			}
		},
		methods: {
			//获取首页数据列表
			async getDataList(){
				if(this.noMore && this.total != 0 ) return
				this.loading = true
				let param = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					userId: localStorage.getItem('userId')||'',
					talkId: this.talkId,
					sortFlag: 0,
					sortType: this.sortType
				}
				ajaxParam(param)
				const res = await post('v1/circle/postList', qs.stringify(param))
				if(res.data.code==200){
					this.loading = false
					this.dataList = this.pageNum==1 ? res.data.list : this.dataList.concat(res.data.list)
					if(!this.noMore){
						this.pageNum++
					}
					this.total = res.data.total
				} else {
					this.loading = false
					this.$message.error(res.data.msg)
				}
			},
			setIndex(index){
				this.active = index
				this.pageNum = 1
				this.dataList = []
				this.total = 0
				this.getDataList()
			},
			focus(){
				this.active = 1
				this.pageNum = 1
				this.dataList = []
				this.total = 0
				this.getDataList()
			}
		}
	}
</script>

<style scoped lang="less">
	.main{
		display: flex;
		justify-content: space-between;
		width: 1180px;
		margin: 20px auto;
		.content{
			position: relative;
			flex: 1;
			background: #fff;
			padding: 10px 40px 40px 40px;
			border-radius: 10px;
			.scroll-container {
				height: 800px;
				border-radius: 4px;
				padding: 20px;
			}

			.infinite-list {
				height: 100%;
				overflow: auto; /* 允许内容滚动 */
				scrollbar-width: none; /* Firefox */
				-ms-overflow-style: none; /* IE */
				padding: 0;
				margin: 0;
				list-style: none;
			}

			.infinite-list::-webkit-scrollbar {
				display: none; /* WebKit 浏览器 */
			}
			.loading-text,
			.no-more-text {
				text-align: center;
				color: #909399;
				padding: 12px;
				font-size: 14px;
			}

			.content-title{
				// position: absolute;
				display: flex;
				margin-bottom: 20px;
			}
			
			.content-title-item{
				padding: 0 20px;
				height: 30px;
				line-height: 30px;
				background: #f2f2f2;
				color: #76767e;
				margin-right: 10px;
				border-radius: 6px;
				font-weight: 400;
				cursor: pointer;
				&.active{
					background-color: #e0e0e0;
					color: #40414f;
				}
			}
			.lable-select{
				width: 100px;
				padding: 0;
				border: none;
				:deep .el-input__inner{
					border:none;
					background: #f2f2f2;
					color:#76767e;
					height: 100%;
				}
				:deep .el-input__suffix{
					right: 10px;
				}
				:deep .el-input--suffix .el-input__inner{
					padding-right: 0 !important;
				}
				:deep .el-select__caret{
					height:30px;
					line-height: 30px;
					color:#76767e;
				}
				&.active{
					:deep .el-input__inner{
					border:none;
					background: #e0e0e0;
					color:#40414f;
					height: 100%;
				}
				}
			}
		}
		.aside{
			width: 300px;
			margin-left: 20px;
		}
	}
	/* 遮罩层样式 */
	.modal-mask {
		position: fixed;
		z-index: 9998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		transition: opacity 0.3s ease;
	}

	/* 弹框容器 */
	.modal-container {
		position: relative;
		width: 290px;
		height: 216px;
		box-sizing: border-box;
		background: white;
		border-radius: 12px;
		padding: 30px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transform: scale(0.9);
		opacity: 0;
		transition: all 0.3s ease;
	}

	/* 入场动画 */
	.modal-enter {
		transform: scale(1);
		opacity: 1;
	}

	/* 关闭按钮 */
	.modal-close {
		position: absolute;
		top: 15px;
		right: 20px;
		width: 17px;
		height: 17px;
		cursor: pointer;
		transition: color 0.3s;
	}

	.modal-close:hover {
		color: #333;
	}

	/* 标题样式 */
	.modal-title {
		text-align: center;
		color: red;
		margin-bottom: 24px;
		font-size: 16px;
	}

	/* 功能列表 */
	.feature-list {
		list-style: none;
		padding: 0;
		margin: 0;
		color: #000;
		margin-left: 30px;
	}

	.feature-item {
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.2s;
		display: flex;
		align-items: center;
		font-size: 13px;
		font-weight: 600;
	}

	.feature-item:hover {
		background: #e9ecef;
		transform: translateX(10px);
	}

	/* 数字编号样式 */
	.item-number {
		display: inline-block;
		width: 24px;
		height: 24px;
		line-height: 24px;
		text-align: center;
		// background: #3498db;
		color: black;
		border-radius: 50%;
		font-size: 14px;
		flex-shrink: 0;
	}
</style>
